import { render, staticRenderFns } from "./AppBottomList.vue?vue&type=template&id=7c3391f4"
import script from "./AppBottomList.vue?vue&type=script&lang=js"
export * from "./AppBottomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports